import { render, staticRenderFns } from "./shipper_grant_creat.vue?vue&type=template&id=2b6c621d&scoped=true&"
import script from "./shipper_grant_creat.vue?vue&type=script&lang=js&"
export * from "./shipper_grant_creat.vue?vue&type=script&lang=js&"
import style0 from "./shipper_grant_creat.vue?vue&type=style&index=0&id=2b6c621d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c621d",
  null
  
)

export default component.exports